export const LOCAL_URL = 'http://localhost:3000/'
console.log(`Using host: ${LOCAL_URL}`)
export const BASE_URL = 'http://localhost:3000/'
